export interface IPrintButtonProps {
  className?: string;
  buttonText: string;
  linkToPrintPage?: string;
  onClick?: () => void;
  disableIframe?: boolean;
}

export enum TPrintButtonAction {
  PrintPageLoaded,
}
